//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ['error'],
  layout: 'default',
  head() {
    return {
      meta: [
        {
          hid: 'prerender-status-code',
          name: 'prerender-status-code',
          content: 404
        },
        {
          name: 'robots',
          content: 'NOINDEX, NOFOLLOW',
          hid: 'robots-hid'
        }
      ],
      link: [
        { rel: 'canonical', href: this.canonicalURL },
      ]
    }
  },
  data() {
    return {
      content: null
    }
  },

  async fetch() {
    this.content = this.$route.path
  },
  computed: {
    canonicalURL() {
       try {
          let canonical = _.find(this.$config.CANONICALS, { 'lang': this.lang })      
          if(canonical) {
            return canonical.domain + this.$route.fullPath
          }
      } catch (e) {
      }

      return this.$config.SEO_CANONICAL + this.$route.fullPath
    },
  },
  methods:{
    openGlobalIframe() {
      this.loadGlobalIframe('open_page', {'url': '/help'})
    }
  }
}
